import apiClient from './apiClient'
import type { ProductDetail } from '@/types'

interface ProductDetailResponse {
  success: boolean
  message: string
  data: ProductDetail
}

class ProductService {
  async getProductDetail(productId: string): Promise<ProductDetail> {
    const response = await apiClient.get(`/api/auth/products/${productId}`)
    return (response as unknown as ProductDetailResponse).data
  }
}

export default new ProductService()
